import React from 'react';
import BaseCreatePage from '../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import * as inspectionCrud from '../../../../crud/inspectionDefect.crud';
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import moment from 'moment';
import { FormattedMessage } from "react-intl";
import { withCreatePageProps } from '../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../shared/common';
import { actionCodes } from "../../../../shared/lookup";
import { addDays, addYears } from 'date-fns';


class DiaryCreatePage extends BaseCreatePage {
    constructor(props) {
        super(props);
        this.createDefaultSubject = ((props.location.state || {}).itemCustomProps || {}).subject;

        //if it's coming from create new via Clause/Type button, try to set default clause display value according to the clauseDisplay passed in location state from clause dropdown
        this.createDefaultClause = (((props.location || {}).state || {}).itemCustomProps || {}).clauseDisplay;

        this.state = {
            showAlert: true,
            selectedClause: null,
        };
    }

    submitHandler = (notification, setSubmitting) => {
        const { fields } = this.props.workflowItem;
        notification.companyid = this.props.contract.companyid;
        notification.contractid = this.props.contract.contractid;
        notification.projectid = this.props.contract.projectid;
        notification.replystatus = 'Not Communicated';
        // notification.notificationdatedisplay = moment().format('DD/MM/YYYY');
        notification.type = this.props.workflowItem.config.currentModelType;
        if (notification.inspectiondatedisplay) {
            notification.inspectiondatedisplay = moment(notification.inspectiondatedisplay).format('DD/MM/YYYY HH:mm:ss');
        }
        if (notification.inspectiontime) {
            notification.inspectiontime = moment(notification.inspectiontime).format('DD/MM/YYYY');
        }
        notification.actioncode = actionCodes.CREATE;
        notification.workflowid = this.props.workflowItem.id;

        if (this.props.workflowItem.replyEnabled) {
            let selectedClause = null;
            if (fields.Type.visible) {
                selectedClause = fields.Type.clauses.find(item => item.display === notification.replycomment);
                if (!selectedClause) {
                    console.log("Clause selection not found!");
                }
            }

            if (notification.replyrequireddate) {
                const replyRequiredDate = moment(notification.replyrequireddate);
                notification.replyrequireddate = moment().set({ 'year': replyRequiredDate.year(), 'month': replyRequiredDate.month(), 'date': replyRequiredDate.date() }).toDate();
            }
        }
        
        this.appendRelationship(notification);
        Common.PropertyConversionsBeforeNoticeSaveRequest(notification, this.props.customFields, this.props.contractUsers);
        inspectionCrud.saveInspectionDefect(notification)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdID = Number(response.data);
                    this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });
    }
    fieldChanged = (field, value, isDxFormValid) => {
        if (field) {
            if (field === 'replycomment') {
                const { fields } = this.props.workflowItem;
                if (fields.Type.visible) {
                    const selectedClause = fields.Type.clauses.find(item => item.display === value);
                    this.setState({ selectedClause: selectedClause });
                }
            }
        }
    }
    render() {
        const { assetid } = ((this.props.location.state || {}).itemCustomProps || {});
        const createFormConfig = {
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };
        const { fields } = this.props.workflowItem;
        if (fields.Subject.visible) {
            createFormConfig.fields.push({ label: fields.Subject.label, dataField: 'replyactiondetail', editorOptions: { defaultValue: this.createDefaultSubject } });
        }
        if (fields.Type.visible) {
            createFormConfig.fields.push({ label: fields.Type.label, dataField: 'replycomment', editorType: 'dxSelectBox', editorOptions: { dataSource: fields.Type.clauses, valueExpr: 'display', displayExpr: 'display', defaultValue: this.createDefaultClause } });
        }

        if (this.props.workflowItem.replyEnabled && fields.ResponseRequiredDate.visible) {
            if (this.state.selectedClause?.noReply) {
                //Do not show Response Required Date field
            } else if (this.state.selectedClause?.applyReplyPeriod && this.state.selectedClause.hasOwnProperty("replyPeriod")) {
                const replyrequireddate = moment(addDays(new Date(), this.state.selectedClause.replyPeriod)).toDate();
                createFormConfig.fields.push({ label: fields.ResponseRequiredDate.label, dataField: 'replyrequireddate', editorType: 'dxDateBox', editorOptions: { readOnly: true, value: replyrequireddate } })
            }
            else if (this.props.workflowItem.replyPeriodOption === "ASKED_ON_COMMUNICATION_FORM") {
                createFormConfig.fields.push({ label: fields.ResponseRequiredDate.label, dataField: 'replyrequireddate', editorType: 'dxDateBox', editorOptions: { calendarOptions: { min: new Date() }, max: addYears(new Date(), 10) }, validation: { type: 'range', min: moment().subtract(1, 'days'), max: addYears(new Date(), 10), warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" }) } });
            } else {
                const replyrequireddate = moment(addDays(new Date(), this.props.workflowItem.replyPeriod)).toDate();
                createFormConfig.fields.push({ label: fields.ResponseRequiredDate.label, dataField: 'replyrequireddate', editorType: 'dxDateBox', editorOptions: { readOnly: true, value: replyrequireddate } })
            }
        }

        if (fields.Details.visible) {
            createFormConfig.fields.push({ label: fields.Details.label, dataField: 'inspectiondetails', editorType: 'dxHtmlEditor' });
        }
        if (fields.StartDate.visible) {
            createFormConfig.fields.push({ label: fields.StartDate.label, dataField: 'inspectiondatedisplay', editorType: 'dxDateBox', editorOptions: { min: new Date(2000, 0, 1) }, validation: { type: 'range', min: new Date(1900, 0, 1) } });
        }
        if (fields.EndDate.visible) {
            createFormConfig.fields.push({ label: fields.EndDate.label, dataField: 'inspectiontime', editorType: 'dxDateBox' });
        }


        return (
            <Portlet>

                <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                <PortletBody style={{ maxWidth: 1000 }}>
                    {this.state.showAlert && (
                        <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                            </p>
                        </Alert>
                    )}
                    <BiDynamicForm
                        onSubmitHandler={this.submitHandler}
                        config={createFormConfig}
                        valueChangeHandler={this.fieldChanged}
                        customFields={(this.props.customFields || {}).COMMUNICATION}
                        assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                        assetid={assetid}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users
});

export default withCreatePageProps(connect(mapStateToProps)(DiaryCreatePage));
